import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

// Modal Video
import ModalVideo from "react-modal-video";
import "../../../node_modules/react-modal-video/scss/modal-video.scss";

// import images
import about from "../../assets/images/company/about2.png";
import features from '../../assets/images/features.svg';

//Import Icons
import FeatherIcon from "feather-icons-react";

export default class Features extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.openModal = this.openModal.bind(this);
  }
  openModal() {
    this.setState({ isOpen: true });
  }
  render() {
    return (
      <React.Fragment>
        <Container id="aboutus">
          <Row className="justify-content-center">
            <Col lg={7} md={6} className="mt-4 mt-lg-0 pt- pt-lg-0">
              <div className="ms-lg-5">
                {/* <span className="badge rounded-pill bg-soft-primary">
                  Features
                </span> */}
                <h2>What we do ?</h2>
                <p className="text-muted para-desc mx-auto mb-0">
                  {" "}
                  <span className="fw-bold " style={{ color: "#018ABF" }}>
                    Turtl
                  </span>{" "}
                  is building India’s next-gen quick commerce and last-mile
                  delivery network, designed for Tier 1, Tier 2, and Tier 3
                  cities because fast delivery isn’t just a metro need. We
                  enable instant delivery (10-30 mins) of groceries, medicines,
                  recurring essentials, heavy/bulk orders, and inter-city
                  specialty goods using an AI-driven dark store network. For
                  brands, we offer plug-and-play hyperlocal delivery
                  infrastructure, allowing them to expand beyond metros and
                  reach customers Pan-India. With AI-powered logistics,
                  real-time demand forecasting, and smart inventory management,
                  we are scaling quick commerce where it’s needed the most.
                </p>

                {/* <h2>Why Now?</h2>
                <ul className="list-unstyled text-muted">
                  <li className="mb-1">
                    <span className="h5 me-2" style={{color:"#018ABF"}}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Rising demand for fast delivery beyond metros
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{color:"#018ABF"}}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Lack of structured last-mile networks in Tier 2 & 3 cities
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{color:"#018ABF"}}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Growing number of brands looking for hyperlocal expansion
                  </li>
                </ul> */}
              </div>
            </Col>
            <Col lg={7} md={6} className="mt-4 mt-lg-0 pt- pt-lg-0">
              <div className="ms-lg-5 my-3">
                {/* <div className="section-title mb-3">
                  * <span className="badge rounded-pill bg-soft-primary">
                    Meet the future
                  </span> 
                  <h4 className="title my-3">Exploring Untapped Markets</h4>
                  <p className="text-muted para-desc">
                    Start working with{" "}
                    <span className="fw-bold" style={{ color: "#018ABF" }}>
                      Turtl
                    </span>{" "}
                    too exapand the Quick Commerce landscape and enable
                    businesses harness the power of technology to create a
                    better living.
                  </p>
                  <p className="text-muted para-desc mb-0">
                    The quick commerce market in India is experiencing
                    exponential growth, with projections indicating a rise from
                    USD 3.49 billion in 2025 to USD 4.35 billion by 2030, at a
                    CAGR of over 4.5% Mordor Intelligence. While major players
                    have concentrated on metropolitan areas, there remains a
                    significant untapped potential in Tier 2 and Tier 3 cities.
                    These regions are witnessing increasing disposable incomes
                    and a growing demand for convenience, making them ripe for
                    quick commerce solutions.
                  </p>
                 </div>  */}

                <h3>Why Now?</h3>

                <ul className="list-unstyled text-muted">
                  <li className="mb-1">
                    <span className="h5 me-2" style={{ color: "#018ABF" }}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Special focus on under-served Tier 2 & Tier 3 markets.
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{ color: "#018ABF" }}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Partnerships with local vendors, small businesses,
                    homemade-item producers.
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{ color: "#018ABF" }}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Deep tech/AI background to personalize user experiences and
                    provide robust analytics for B2B.
                  </li>
                </ul>

                <h3>Our Progresss</h3>

                <ul className="list-unstyled text-muted">
                  <li className="mb-1">
                    <span className="h5 me-2" style={{ color: "#018ABF" }}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    MVP in development – Customer, rider & stock management apps
                    launching soon
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{ color: "#018ABF" }}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Dark store network setup in progress – Targeting key cities
                    for launch
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{ color: "#018ABF" }}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    B2B expansion plan – Helping brands activate quick commerce
                    with our logistics
                  </li>
                </ul>

                {/* <div className="mt-3">
                  <Link
                    to="//1.envato.market/landrickreactjs"
                    target="_blank"
                    className="btn btn-primary m-1"
                  >
                    Read More{" "}
                    <i className="uil uil-angle-right-b align-middle"></i>
                  </Link>{" "}
                  <Link
                    to="#"
                    className="btn btn-icon btn-pills video-play-icon btn-primary m-1"
                    onClick={this.openModal}
                  >
                    <i>
                      <FeatherIcon icon="video" className="icons" />{" "}
                    </i>
                  </Link>
                  <span className="fw-bold text-uppercase small align-middle ms-1">
                    Watch Now
                  </span>
                </div> */}
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={4} md={6} className="mt-4 pt-2">
              <Card className="border-0 text-left features feature-primary feature-clean rounded p-4">
                <div className="icons text-left mx-auto">
                  <i
                    className="uil uil-stopwatch d-block text-center rounded h3 mb-0"
                    style={{ color: "#018ABF" }}
                  ></i>
                </div>

                <CardBody className="p-0 mt-4">
                  <h5 className="text-center">Turtl Commerce</h5>
                  <p className="text-muted mb-0">
                    We bring quick commerce to every city tier, delivering
                    groceries, FMCG products, medicines, and everyday essentials
                    in minutes..
                  </p>
                  <ul className="list-unstyled text-muted">
                    <li className="mb-1">
                      <span className="h5 me-2" style={{ color: "#018ABF" }}>
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Instant delivery (10-30 mins) beyond metros
                    </li>
                    <li className="mb-1">
                      <span className="h5 me-2" style={{ color: "#018ABF" }}>
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Scheduled & recurring orders for convenience
                    </li>
                    <li className="mb-1">
                      <span className="h5 me-2" style={{ color: "#018ABF" }}>
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Hyperlocal sourcing from trusted vendors
                    </li>
                  </ul>
                  {/* <div className="mt-2">
                    <Link to="#" style={{ color: "#018ABF" }}>
                      Read More{" "}
                      <i>
                        <FeatherIcon
                          icon="arrow-right"
                          className="fea icon-sm"
                        />
                      </i>
                    </Link>
                  </div> */}
                </CardBody>
              </Card>
            </Col>

            <Col lg={4} md={6} className="mt-4 pt-2">
              <Card className="border-0 text-left features feature-primary feature-clean rounded p-4">
                <div className="icons text-left mx-auto">
                  <i
                    className="uil uil-building d-block text-center rounded h3 mb-0"
                    style={{ color: "#018ABF" }}
                  ></i>
                </div>

                <CardBody className="p-0 mt-4">
                  <h5 className="text-center">Turtl Corporate</h5>
                  <p className="text-muted mb-0">
                    We empower brands with Turtl’s Dark Store-as-a-Service,
                    enabling them to activate quick commerce across new regions.
                  </p>

                  <ul className="list-unstyled text-muted">
                    <li className="mb-1">
                      <span className="h5 me-2" style={{ color: "#018ABF" }}>
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Plug & play last-mile delivery for brands
                    </li>
                    <li className="mb-1">
                      <span className="h5 me-2" style={{ color: "#018ABF" }}>
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      1–2 hour ultra-fast fulfillment from dark stores
                    </li>
                    <li className="mb-1">
                      <span className="h5 me-2" style={{ color: "#018ABF" }}>
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      AI-driven inventory optimization for efficiency
                    </li>
                  </ul>
                  {/* <div className="mt-2">
                    <Link to="#" style={{ color: "#018ABF" }}>
                      Read More{" "}
                      <i>
                        <FeatherIcon
                          icon="arrow-right"
                          className="fea icon-sm"
                        />
                      </i>
                    </Link>
                  </div> */}
                </CardBody>
              </Card>
            </Col>

            {/* <Col lg={4} md={6} className="mt-4 pt-2">
              <Card className="border-0 text-center features feature-primary feature-clean rounded p-4">
                <div className="icons text-center mx-auto">
                  <i className="uil uil-circle-layer d-block rounded h3 mb-0"></i>
                </div>

                <CardBody className="p-0 mt-4">
                  <h5>Design & Branding</h5>
                  <p className="text-muted mb-0">
                    Composed in a pseudo-Latin language which more or less
                    pseudo-Latin language corresponds.
                  </p>
                  <div className="mt-2">
                    <Link to="#" className="text-primary">
                      Read More{" "}
                      <i>
                        <FeatherIcon
                          icon="arrow-right"
                          className="fea icon-sm"
                        />
                      </i>
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col> */}
          </Row>
        </Container>
        <Container className="mt-100 mt-60" id="highlights">
          <Row className="align-items-center">
            <Col lg={5} md={6}>
              <img src={features} className="img-fluid" alt="" />
            </Col>

            <Col lg={7} md={6} className="mt-4 mt-lg-0 pt- pt-lg-0">
              <div className="ms-lg-5">
                <div className="section-title mb-3">
                  {/* <span className="badge rounded-pill bg-soft-primary">
                    Meet the future
                  </span> */}
                  <h4 className="title my-3">
                    Unlocking India’s Next Growth Market
                  </h4>
                  <p className="text-muted para-desc">
                    {" "}
                    <span className="fw-bold" style={{ color: "#018ABF" }}>
                      Turtl
                    </span>{" "}
                    is expanding quick commerce beyond metros, helping
                    businesses tap into Tier 2 & Tier 3 cities where demand is
                    rising but infrastructure remains limited.
                  </p>
                  <p className="text-muted para-desc mb-0">
                    The quick commerce market in India is set to grow from
                    $3.49B in 2025 to $4.35B by 2030 (CAGR 4.5%, Mordor
                    Intelligence). While major players dominate metro cities,
                    there is a massive untapped opportunity in smaller cities
                    where disposable incomes are rising, and convenience-driven
                    shopping is increasing.
                  </p>
                </div>

                <h4>Why Turtl?</h4>

                <ul className="list-unstyled text-muted">
                  <li className="mb-1">
                    <span className="h5 me-2" style={{ color: "#018ABF" }}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Focused on under-served Tier 2 & Tier 3 markets where
                    competition is low, but demand is growing.
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{ color: "#018ABF" }}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Partnering with local vendors, small businesses, and
                    homemade product sellers to create a hyperlocal ecosystem.
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{ color: "#018ABF" }}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Leveraging AI & deep tech for smart inventory placement,
                    demand forecasting, and real-time analytics for brands.
                  </li>
                </ul>

                <h5>
                  Turtl is building the infrastructure for India's next wave of
                  quick commerce expansion—empowering businesses to scale
                  faster, reach new customers, and unlock new revenue streams.{" "}
                </h5>

                {/* <div className="mt-3">
                  <Link
                    to="//1.envato.market/landrickreactjs"
                    target="_blank"
                    className="btn btn-primary m-1"
                  >
                    Read More{" "}
                    <i className="uil uil-angle-right-b align-middle"></i>
                  </Link>{" "}
                  <Link
                    to="#"
                    className="btn btn-icon btn-pills video-play-icon btn-primary m-1"
                    onClick={this.openModal}
                  >
                    <i>
                      <FeatherIcon icon="video" className="icons" />{" "}
                    </i>
                  </Link>
                  <span className="fw-bold text-uppercase small align-middle ms-1">
                    Watch Now
                  </span>
                </div> */}
              </div>
            </Col>
          </Row>
        </Container>
        <ModalVideo
          channel="youtube"
          isOpen={this.state.isOpen}
          videoId="yba7hPeTSjk"
          onClose={() => this.setState({ isOpen: false })}
        />
      </React.Fragment>
    );
  }
}
